module.exports = __webpack_public_path__ + "static/media/Roka.2ab449de.svg";